import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const openAppRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/open-app',
  validateSearch: z.object({
    path: z.string().optional(),
  }),
}).lazy(() => import('pages/shared/OpenAppPage/OpenAppPage').then((d) => d.Route));
